import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import WriteForUs from "../components/writeForUs"
import image from "../images/write-for-us.svg"

const WriteFor = () => {
  const sectionData = {
    title: `Write For Us`,
    description:
      "Welcome! We appreciate your interest in writing for Wersel Workdesk. We are building a community of industry’s preeminent thought leaders and we want your voice.",
    image,
    contents: [
      {
        title: "Guest-Posting for Wersel",
        content: `We cordially welcome you to write a guest-post for our official blog.\n\nGuest blogging is a great way to establish yourself as an authority figure within the market and build relationships with other bloggers and experts within your field. It is also an excellent way to enhance your presence on the web. We, Wersel, are looking for savvy writers, experts, and professional writers, who are interested in writing guest-posts on different topics.\n\nHere, for our official blog, you can submit your post as a guest blogger and can get good benefits as per our guest blogger’s policy. `,
      },
      {
        title: "Why should you write for us?",
        content: `We’re simply amazing to work with!\n\nOur blogs are been read and followed by the reader all around the globe. More importantly, we’re committed to hosting the best blog we can to serve our rapidly growing audience. You will have the benefits in many ways like lots of visitors, targeted audience, backlinks and more.`,
      },
      {
        title: "What Type of Articles we accept?",
        content: "The following type of articles we welcome",
        unorderedList: [
          "Big data, Business Analytics, and BI news, trends, and developments ",
          "Machine Learning market trends",
          "How-tos, challenges, and best practices",
          "Visualization techniques and ideas",
          "Defining and understanding business metrics",
        ],
      },
    ],
    points: [
      {
        title: "Dos and Don’ts",
        subTitle: "Do:",
        unorderedList: [
          "Be Original. Please don’t just rewrite other articles on the internet. Add something interesting to the blog you submit.",
          "Ensure that the length of the articles you submit range somewhere between 1000 to 2,000 words.",
          "Use original images or attribute images that are not your own. Image width should be 800px, wherever possible.",
          "Add resources to your article wherever possible and support your arguments with studies and research.",
          "Please do not add information that is not accurate or make up statistics that suit your needs.",
        ],
      },
      {
        title: "",
        subTitle: "Don’t:",
        unorderedList: [
          "Plagiarize. Please do not simply submit work that has already been on the internet or even a rewrite of someone else’s work.",
          "Give articles that add no value or meaning to your readers. Each article you write should have a specific purpose.",
          "Submit articles with bad grammar or sentence structure. Understanding technology is difficult enough without them having to wade through bad sentence structures or grammar. Please proof-read your articles before submission or have someone who has impeccable grammar edit your articles.",
          "Use images without copyright or attribution. We do not appreciate plagiarism threats or cases, so ensure that you always attribute work that is not yours.",
        ],
      },
      {
        title: "Submission Guidelines",
        subTitle: "",
        unorderedList: [
          "Posts must be “AT LEAST!” 1200+ words long, preferably more. We only want the best for our readers and posts shorter than this tend to be less helpful.",
          "We only accept articles that are written in English at this moment.",
          "Articles must be written by you and totally original! We will be checking ALL submissions for breach of copyright.",
          "We reserve the right to format/edit the submitted articles.",
          "Add images to convey your message, don’t add it just for the sake of it. If writing tutorials, take a screenshot.",
        ],
      },
    ],
    conclusion: [
      {
        title: "Submitting Your Post",
        content: `In order for you to become a regular writer, you will first have to pitch us a post and show us your writing skills and knowledge. So, what should you submit?\n\nBriefly introduce yourself and the type of content you are comfortable with writing. What are your strengths in terms of technology and in what segments would you excel. Provide us with your writing portfolio and/or samples of previous writing, which can also include other guest posts.\n\nIf you agree to the terms and conditions mentioned above, please contact us hello@wersel.io\n\nIf you are successful in submitting an article to us, we will give you full credit at the bottom of your post with a featured ‘bio’. Here you can include a bit of information about yourself and your website, as well as links to your Twitter, LinkedIn profiles.\n\nPlease note that it usually takes us 48 hours to go through the submission, so please be patient. We will get back to you within that time frame.`,
      },
    ],
  }
  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        title="Write For Us – Wersel Workdesk"
        description="Welcome! We appreciate your interest in writing for Wersel. We are building a community of industry’s preeminent thought leaders and we want your voice."
        keywords="Data analytics write for us, big data write for us, write for us"
        url="www.wersel.io/write-for-us"
      />
      <WriteForUs sectionData={sectionData} />
    </Layout>
  )
}

export default WriteFor
